import { ActionWidgetComponent } from '../../action-widget/action-widget.component';
import { CarouselBannerComponent } from '../../../../carousel-banner/carousel-banner.component';
import { MapfreCardComponent } from '../../../../../modules/mapfre-design-library/src/lib/_components/wrapper-components/mapfre-card/mapfre-card.component';
import { SystemMaintenanceComponent } from '../../../../screens/system-maintenance/system-maintenance.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { AcmicService } from '@mapfre-design-library/src/public_api';
import { SortByStatusPipe } from '@helpers/_pipes/sort-by-status.pipe';
import { TitleCaseHyphenatedNamePipe } from '@helpers/_pipes/titlecase-hyphenated-name.pipe';
import { UserDataService } from '@services/data-services/user-data.service';
import { CustomerContextService } from '@services/data-services/customer-context.service';
import { PolicyDataService } from '@services/data-services/policy-data.service';
import { BillingNewService } from '@services/common/billing-new.service';
import { AuthStateService } from '@mapfre-design-library/src/lib/_services/auth-state.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

import { NonRenewalNoticeComponent } from '@loggedin-content/nonrenewal-notice-update/non-renewal-notice/non-renewal-notice.component';
@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, SystemMaintenanceComponent, MapfreCardComponent, CarouselBannerComponent, ActionWidgetComponent,NonRenewalNoticeComponent],
  selector: 'app-my-insurance-home',
  templateUrl: './my-insurance-home.component.html',
  styleUrls: ['./my-insurance-home.component.scss'],
  providers: [SortByStatusPipe, TitleCaseHyphenatedNamePipe],
})
export class MyInsuranceHomeComponent implements OnInit, OnDestroy {
  userFirstName = '';
  isAcmic: boolean;
  showMessage: boolean;
  hideAlert = false;
  isGWPolicy: boolean;
  tokenReady = false;
  paymentNotificationData: any;
  paymentDate = '';
  showManageWallet: boolean;
  showPayByText: boolean;
  isThereAnyActiveGWPolicy: boolean;
  destroy$ = new Subject<void>();

  constructor(
    private acmicService: AcmicService,
    private userDataService: UserDataService,
    private policyDataService: PolicyDataService,
    private billingNewService: BillingNewService,
    private customerContextService: CustomerContextService,
    private authStateService: AuthStateService
  ) {}

  public ngOnInit() {
    this.billingNewService.hideBanner$.pipe(takeUntil(this.destroy$)).subscribe((res)=>{
      this.hideAlert = res;
    });
    this.isAcmic = this.acmicService.isACMIC();
    this.getUserData();
    this.getPolicy();
    this.authStateService.tokenReady$.pipe(takeUntil(this.destroy$)).subscribe(res => {
      this.tokenReady = res;
    });
  }

  
  getPolicy(){
   this.policyDataService.$rawPolicies.pipe(takeUntil(this.destroy$)).subscribe(
    res=>{
      if(res){
        this.isThereAnyActiveGWPolicy = this.isActiveGwPolicyExist(res);
      }
    });
  }


  getUserData() {
    this.customerContextService
      .ensureAccountHolder()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (accountHolder) => {
          if (accountHolder?.firstName && !this.userFirstName) {
            this.userFirstName = accountHolder.firstName;
          }
        },
        error: () => {
          /* fall through to the userData fallback below */
        },
      });
    // Last-resort fallback: identity API (slowest)
    this.userDataService.$userData.pipe(takeUntil(this.destroy$)).subscribe((user) => {
      if (user?.userDetails?.firstName && !this.userFirstName) {
        this.userFirstName = user.userDetails.firstName;
      }
    });
  }

  closeModal(event) {
    void event;
    this.showMessage = false;
  }

  onClose() {
    this.billingNewService.setBannerState(true);
  }


  isActiveGwPolicyExist(maGWPolicy) {
    if (Array.isArray(maGWPolicy)) {
      return maGWPolicy.some(policy => (policy.policynumber?.policyNumber?.length === 10 && policy?.policyStatus === 'ACTIVE'));
    }
    return false;
  }

  ngOnDestroy(): void {
    this.destroy$.next();
  }
}